// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__3i9hO","panelNavbarChildens":"panel_panelNavbarChildens__2BfWS"};